import { render, staticRenderFns } from "./SelectionQuestion.vue?vue&type=template&id=578c01e6"
import script from "./SelectionQuestion.vue?vue&type=script&lang=js"
export * from "./SelectionQuestion.vue?vue&type=script&lang=js"
import style0 from "./SelectionQuestion.vue?vue&type=style&index=0&id=578c01e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports